<template>
  <Modal
    v-model="visible"
    :title="$t(title)"
    v-bind="config.modalBind"
    :width="
      fullscreen
        ? '100%'
        : config.modalBind && config.modalBind.width
        ? config.modalBind.width
        : config.width
    "
    @on-ok="ok"
    :footer-hide="!isMethod(footer.show, null, true) || footer_hide"
    sticky
    transfer
    reset-drag-position
    :draggable="draggable"
    :fullscreen="fullscreen"
    @on-cancel="cancel"
    :styles="{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      ...(config.modalBind && config.modalBind.styles),
      ...(fullscreen ? { top: 0 } : {})
    }"
    ref="modal"
  >
    <div
      slot="close"
      style="
                color: black;
                line-height: 36px;
                font-size: 20px;
                display: flex;
                align-items: center;
              "
    >
      <Icon type="ios-expand" @click.stop="setScreen" />
      <Icon @click.stop="close()" type="ios-close" />
    </div>
    <div
      slot="header"
      v-if="isMethod(header.show, null, false)"
      v-bind="header.bind"
      style="width: calc(100% - 30px); display: flex; align-items: center"
    >
      <span style="font-size: 16px; font-weight: bold">
        {{ $t(title) }}
      </span>
      <template v-if="header.copy">
        <Button
          size="small"
          @click.stop="
            handleMethod({
              methods: header.methods,
              name: 'copy',
              row: params.row ? params.row : params
            })
          "
          type="warning"
          style="margin: 0 10px"
        >
          {{ $t("copy") }}
        </Button>
      </template>
      <template v-if="header.btns">
        <template v-for="btn in header.btns">
          <Button
            v-if="hasPermission(btn.id) && isMethod(btn.show, null, true)"
            :key="btn.type"
            :disabled="isMethod(btn.disabled)"
            @click="
              handleMethod({
                methods: header.methods,
                name: btn.fnName || 'click',
                row: params.row,
                field: btn,
                fields: header.btns
              })
            "
            size="small"
            v-bind="btn.bind"
          >
            {{ isMethod(btn.name) }}
          </Button>
        </template>
      </template>
    </div>
    <div v-bind="config.modalContentBind">
      <slot
        :name="modal.contentTop"
        :visible="visibleDelay"
        :close="close"
        :params="params"
      ></slot>
      <div style="height: 100%" v-bind="config.modalContentCenterBind">
        <span
          style="marign-right: 10px"
          v-if="modal.topRender"
          v-bind="config.topBind"
        >
          {{ handleMethod({ methods: modal, name: "topRender" }) }}
        </span>
        <Button
          style="margin-right: 10px; margin-bottom: 10px"
          v-for="btn in btnList"
          :key="btn.type"
          :disabled="isMethod(btn.disabled, { searchForm })"
          :size="btn.size"
          @click="
            handleMethod({
              methods: btns.methods,
              name: btn.fnName || 'click',
              field: btn,
              searchForm
            })
          "
          v-bind="btn.bind"
        >
          {{ isMethod(btn.name) }}
        </Button>
        <slot
          :name="modal.contentSlot"
          :visible="visibleDelay"
          :close="close"
          :params="params"
        >
          <ContentExpand
            v-if="modal.render"
            :render="modal.render"
            :row="params"
            v-bind="modal.bind"
          ></ContentExpand>
          <span v-if="modal.content">{{ modal.content }}</span>
        </slot>
        <template v-if="config.tableTop">
          <div v-if="table.fields && table.header && visibleDelay">
            <cHeader
              ref="header"
              @getList="getList"
              :pageConfig="pageConfig"
              :header="table.header"
              :config="table.header.config"
              :searchs="table.header.searchs"
              :btns="table.header.btns"
            ></cHeader>
          </div>
          <Card v-if="table.group" dis-hover style="margin-bottom: 20px">
            <div slot="title" v-if="table.group.render">
              <ContentExpand
                :render="table.group.render"
                v-bind="table.group.bind"
              ></ContentExpand>
            </div>
            <div slot="title" v-else>
              {{ isMethodDefault(table.group.title, "", table.group.title) }}
            </div>
            <vxeTable
              ref="table"
              v-if="
                isMethod(table.show, null, true) && table.fields && visibleDelay
              "
              :list="list"
              :fields="table.fields"
              :config="table.config"
              @checkTable="checkTable"
            >
              <template
                v-for="slot in modal.slots"
                #[slot]="{ row, rowIndex, field, visible }"
              >
                <slot
                  :name="slot"
                  :row="row"
                  :visible="visible"
                  :rowIndex="rowIndex"
                  :field="field"
                ></slot>
              </template>
            </vxeTable>
          </Card>
          <template v-else>
            <vxeTable
              ref="table"
              v-if="
                isMethod(table.show, null, true) && table.fields && visibleDelay
              "
              :list="list"
              :fields="table.fields"
              :config="table.config"
              @checkTable="checkTable"
            >
              <template
                v-for="slot in modal.slots"
                #[slot]="{ row, rowIndex, field, visible }"
              >
                <slot
                  :name="slot"
                  :row="row"
                  :visible="visible"
                  :rowIndex="rowIndex"
                  :field="field"
                ></slot>
              </template>
            </vxeTable>
          </template>
          <div v-if="table.fields && table.footer && visibleDelay">
            <cFooter
              ref="footer"
              @getList="getList"
              @changeSize="changeSize"
              @changePage="changePage"
              :pageConfig="pageConfig"
              :footer="table.footer"
              :fields="table.fields"
            ></cFooter>
          </div>
        </template>
        <cForm
          ref="form"
          v-if="fields.length && visibleDelay && !config.hideForm"
          v-show="isMethodDefault(config.showForm, { params }, true)"
          :fields="fields"
          :grid="grid"
          :config="config"
          :table="table"
          :buttons="buttons"
          @updateFormData="updateFormData"
        >
          <template v-for="slot in modal.slots" #[slot]="{ params, close }">
            <slot
              :name="slot"
              :field="modal"
              :visible="visibleDelay"
              :params="params"
              :close="close"
            ></slot>
          </template>
        </cForm>
        <slot
          :name="modal.formBottom"
          :visible="visibleDelay"
          :close="close"
          :params="params"
        ></slot>
        <div v-if="pageConfig.loading" class="loading-div">
          <Button loading shape="circle" type="primary"></Button>
          <div>loading...</div>
        </div>
        <template v-if="!config.tableTop">
          <div v-if="table.fields && table.header && visibleDelay">
            <cHeader
              ref="header"
              @getList="getList"
              :pageConfig="pageConfig"
              :header="table.header"
              :config="table.header.config"
              :searchs="table.header.searchs"
              :btns="table.header.btns"
            ></cHeader>
          </div>
          <Form ref="tableForm" :model="{ table: list }">
            <Card v-if="table.group" dis-hover style="margin-bottom: 20px">
              <div slot="title" v-if="table.group.render">
                <ContentExpand
                  :render="table.group.render"
                  v-bind="table.group.bind"
                ></ContentExpand>
              </div>
              <div slot="title" v-else>
                {{ isMethodDefault(table.group.title, "", table.group.title) }}
                <!-- <template v-if="table.group.btnList">
				        <template v-for="btn in table.group.btnList">
				          <Button
				            v-if="hasPermission(btn.id)"
				            :key="btn.type"
				            :disabled="isMethod(btn.disabled)"
				            @click="
				              handleMethod({
				                methods: table.group.btnList.methods,
				                name: btn.fnName || 'click',
				                row: params.row
				              })
				            "
				            size="small"
				            v-bind="btn.bind"
				          >
				            {{ isMethod(btn.name) }}
				          </Button>
				        </template>
				      </template> -->
              </div>
              <vxeTable
                ref="table"
                v-if="
                  isMethod(table.show, null, true) &&
                    table.fields &&
                    visibleDelay
                "
                :list="list"
                :fields="table.fields"
                :config="table.config"
                @checkTable="checkTable"
              >
                <template
                  v-for="slot in modal.slots"
                  #[slot]="{ row, rowIndex, field, visible }"
                >
                  <slot
                    :name="slot"
                    :row="row"
                    :visible="visible"
                    :rowIndex="rowIndex"
                    :field="field"
                  ></slot>
                </template>
              </vxeTable>
            </Card>
            <template v-else>
              <vxeTable
                ref="table"
                v-if="
                  isMethod(table.show, null, true) &&
                    table.fields &&
                    visibleDelay
                "
                :list="list"
                :fields="table.fields"
                :config="table.config"
                @checkTable="checkTable"
              >
                <template
                  v-for="slot in modal.slots"
                  #[slot]="{ row, rowIndex, field, visible }"
                >
                  <slot
                    :name="slot"
                    :row="row"
                    :visible="visible"
                    :rowIndex="rowIndex"
                    :field="field"
                  ></slot>
                </template>
              </vxeTable>
            </template>
          </Form>
          <div v-if="table.fields && table.footer && visibleDelay">
            <cFooter
              ref="footer"
              @getList="getList"
              @changeSize="changeSize"
              @changePage="changePage"
              :pageConfig="pageConfig"
              :footer="table.footer"
              :fields="table.fields"
            ></cFooter>
          </div>
        </template>
      </div>
      <slot
        :name="modal.contentBottom"
        :visible="visibleDelay"
        :close="close"
        :params="params"
      ></slot>
    </div>
    <div
      slot="footer"
      v-if="isMethod(footer.show, null, true)"
      v-bind="footer.bind"
    >
      <slot :name="modal.footerSlot">
        <Button
          v-if="!footer.cancel || (footer.cancel && !footer.cancel.isShow)"
          type="text"
          @click="close"
          v-bind="$page.getObj(footer, 'cancel.bind')"
        >
          {{
            isMethod(footer.cancel && footer.cancel.name) ||
              $page.getObj(footer, "cancel.name") ||
              $t("cancel")
          }}
        </Button>
        <Button
          v-if="
            (!footer.ok || (footer.ok && !footer.ok.isShow)) &&
              hasPermission(footer.ok ? footer.ok.id : '')
          "
          :disabled="disabledConfirm"
          :loading="loadingConfirm"
          @click="ok"
          type="primary"
          v-bind="$page.getObj(footer, 'ok.bind')"
        >
          {{
            isMethod(footer.ok && footer.ok.name) ||
              $page.getObj(footer, "ok.name") ||
              $t("confirm")
          }}
        </Button>
        <template v-if="footer.btns">
          <template v-for="btn in footer.btns">
            <Button
              v-if="btn.isVif && hasPermission(btn.id)"
              :key="btn.type"
              :disabled="isMethod(btn.disabled)"
              :size="btn.size"
              @click="ok(btn)"
              v-bind="btn.bind"
            >
              {{ btn.name }}
            </Button>
            <Button
              v-if="
                !btn.isVif &&
                  hasPermission(btn.id) &&
                  isMethod(btn.show, null, true)
              "
              :key="btn.type"
              :disabled="isMethod(btn.disabled)"
              :size="btn.size"
              @click="
                handleMethod({
                  methods: footer.methods,
                  name: btn.fnName || 'click',
                  field: btn
                })
              "
              v-bind="btn.bind"
            >
              {{ btn.name }}
            </Button>
          </template>
        </template>
      </slot>
    </div>
  </Modal>
</template>

<script>
import cHeader from "./header.vue";
import cFooter from "./footer.vue";
import cForm from "./form.vue";
import vxeTable from "./table.vue";
import ContentExpand from "./expand";
import copyClick, { copyToClipboard } from "@/utils/copyClick";
export default {
  provide() {
    return {
      $modal: this
    };
  },
  inject: ["$page"],
  components: {
    cForm,
    cHeader,
    cFooter,
    vxeTable,
    ContentExpand
  },
  props: {
    modal: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      draggable: true,
      fullscreen: false,
      loadingConfirm: false,
      params: {},
      title: "popup",
      visible: false,
      fields: [],
      grid: [],
      buttons: [],
      config: {},
      table: { config: {}, fields: [] },
      btns: {},
      list: [],
      selectAll: [],
      methods: {},
      disabledConfirm: false,
      originFormData: {},
      footer: {},
      header: {},
      searchForm: {},
      pageConfig: {
        pageSize: [15, 50, 100, 500],
        total: 0,
        size: 15,
        page: 1,
        loading: false,
        data: {}
      },
      visibleDelay: false,
      type: "",
      footer_hide: false
    };
  },
  computed: {
    btnList() {
      return this.btns.list;
    }
  },
  watch: {
    visible(val) {
      clearTimeout(this.modalCloseTime);
      if (val) this.visibleDelay = val;
      else {
        this.modalCloseTime = setTimeout(() => {
          this.visibleDelay = val;
        }, 200);
      }
    }
  },
  mounted() {},
  methods: {
    getTable() {
      return this.$refs["table"].$refs["xTable"];
    },
    setScreen() {
      this.fullscreen = !this.fullscreen;
      this.draggable = !this.fullscreen;
    },
    test(text) {
      alert(text || "test");
    },
    getFormData() {
      return this.$refs["form"].formData;
    },
    openLoading() {
      this.pageConfig.loading = true;
    },
    closeLoading() {
      this.pageConfig.loading = false;
    },
    copy(row) {
      copyClick.copyToClipboard(row.airway_number, this);
    },
    hasPermission(id) {
      return this.$hasPermission(id);
    },
    handleFilterData(data) {
      return this.$refs["form"].handleFilterData(data);
    },
    isMethodDefault(methods, params, df) {
      if (typeof methods === "function") return methods.call(this, params);
      return df;
    },
    isMethod(methods, params, df) {
      if (typeof methods === "function") return methods.call(this, params);
      return methods !== undefined ? methods : df;
    },
    updateFormData(formData) {
      if (this.modal.type == "add") return;
      let isNull = true;
      let fieldKeys = this.fields.map(item => item.key);
      let disabled = Object.keys(this.originFormData).find(item => {
        if (fieldKeys.includes(item)) isNull = false;
        if (
          this.originFormData &&
          this.originFormData[item] &&
          this.originFormData[item].toString().indexOf("00:00:00") !== -1
        ) {
          this.originFormData[item] = new Date(this.originFormData[item]);
        }
        return (
          fieldKeys.includes(item) &&
          JSON.stringify(formData[item]) !==
            JSON.stringify(this.originFormData[item])
        );
      });
      this.disabledConfirm = !isNull && disabled === undefined;
    },
    setTitle(title) {
      this.title = this.isMethod(title);
    },
    getFormData() {
      return this.$refs["form"].formData;
    },
    showFooter() {
      this.footer_hide = false;
    },
    hideFooter() {
      this.footer_hide = true;
    },
    setFormData(data) {
      this.originFormData = JSON.parse(JSON.stringify(data));
      Object.assign(this.$refs["form"].formData, data);
      this.updateFormData(data);
    },
    handleMethod(params) {
      let { methods, name, row, field } = params;
      if (methods && methods[name])
        return methods[name].call(this, {
          ...params,
          row,
          field,
          value: row && row[field && field.key]
        });
    },
    open(params, callback) {
      let modal = this.modal;

      let extend = params ? params.extend || {} : {};
      modal.table = modal.table || {};
      modal.table.fields &&
        modal.table.fields.forEach(item => {
          if (item.render) {
            item.render = item.render.bind(this);
            if (!item.component) item.component = "TableExpand";
          }
        });
      this.params = params || {};
      this.fields = extend.fields || modal.fields || [];
      this.fields.forEach(item => {
        if (params && params[item.key] && item.component == "InputNumber") {
          params[item.key] = parseFloat(params[item.key]);
        }
      });
      this.buttons = extend.buttons || modal.buttons;
      this.grid = extend.grid || modal.grid;
      this.config = extend.config || modal.config || {};
      this.btns = extend.btns || modal.btns || {};
      if (this.config.title) this.setTitle(this.config.title);
      let table = extend.table || modal.table;

      if (table && table.fields)
        table.fields.forEach((item, index) => {
          if (!item.options) item.options = [];
          item.slots = [item.slot];
        });
      this.table = table;

      this.footer = extend.footer || modal.footer || {};
      this.header = extend.header || modal.header || {};
      this.pageConfig = Object.assign(
        {
          pageSize: [15, 100, 500, 1000, 5000],
          total: 0,
          size: 15,
          page: 1,
          loading: false,
          data: {}
        },
        this.footer.pageConfig || {}
      );
      this.methods = extend.methods || modal.methods || {};
      if (params && params.extend) delete params.extend;
      this.visible = true;
      this.$nextTick(() => {
        params &&
          this.fields.length &&
          !this.config.hideForm &&
          this.setFormData(params);
        callback && callback.call(this);
        this.handleMethod({
          methods: this.methods,
          name: "open",
          fields: this.fields,
          list: this.list
        });
      });
    },
    close() {
      this.visible = false;
      this.cancel();
    },
    tableRule() {
      console.log("chufa");
      return new Promise((res, rej) => {
        if (!this.$refs["tableForm"]) return res();
        this.$refs["tableForm"].validate(valid => {
          if (valid) res();
          else {
            this.$Message.error(this.$tz("请完善表格"));
            rej();
          }
        });
      });
    },
    async ok(btn) {
      try {
        let res = {};
        if (this.$refs["form"]) res = await this.$refs["form"].submit();
        else res = this.params;
        if (this.list.length >= 1) {
          if (this.list.length == 1) {
            let values = Object.values(this.list[0]);
            console.log("values :>> ", values);
            values = values.find(
              t => t && (typeof t === "string" ? !t.includes("row_") : true)
            );
            console.log("values :>> ", values);
            if (values) await this.tableRule();
          } else await this.tableRule();
        }

        this.handleMethod({
          methods: this.methods,
          name: btn.fnName ? btn.fnName : "ok",
          row: res,
          fields: this.fields,
          list: this.list,
          close: this.close,
          btn: btn
        });
      } catch (e) {
        //TODO handle the exception
        console.log(e);
      }
    },
    getSearchForm() {
      if (this.$refs["header"] && this.$refs["header"].searchForm) {
        return this.$refs["header"].handleFilterData();
      } else return {};
    },
    cancel() {
      this.list = [];
      // this.$refs["form"] && this.$refs["form"].clear();
      this.handleMethod({
        methods: this.methods,
        name: "cancel",
        row: this.params,
        formData: this.$refs["form"] && this.$refs["form"].formData
      });
    },
    async getList(obj) {
      if (this.methods["list"]) {
        return this.handleMethod({
          methods: this.methods,
          name: "list",
          row: this.params
        });
      }
      this.pageConfig.loading = true;

      try {
        this.list = [];
        let params = {
          page: this.pageConfig.page,
          pageSize: this.pageConfig.size,
          ...this.pageConfig.data,
          ...obj,
          ...this.getSearchForm()
        };

        let data = (
          await this.$page.handleRequestMethods(
            this.config.listFn || "modalList",
            params
          )
        ).payload;
        let newList = this.$page.handleMethods("beforeModalList", {
          list: this.list,
          data
        });
        if (!this.config.isNoPage) {
          if (newList) data.rows = newList;
          this.list = data.rows;
          this.pageConfig.total = data.total;
        } else {
          if (newList) data.rows = newList;
          this.list = data;
        }

        this.$nextTick(() => {
          this.handleMethod({
            methods: this.methods,
            name: "afterHandleList",
            row: this.params,
            list: this.list,
            formData: this.$refs["form"] && this.$refs["form"].formData
          });
        });
      } catch (e) {
        //TODO handle the exception
        console.log(e);
      } finally {
        this.pageConfig.loading = false;
      }
    },
    checkTable(val) {
      console.log(val, "checkTable");
      this.selectAll = val;
      this.handleMethod({
        methods: this.methods,
        name: "checkTable",
        row: val
      });
    },
    changeSize(val) {
      this.handleMethod({
        methods: this.table.footer && this.table.footer.methods,
        name: "changeSize"
      });
    },
    changePage(val) {
      this.handleMethod({
        methods: this.table.footer && this.table.footer.methods,
        name: "changePage"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.header-show {
  width: ~"calc(100% - 40px)";
}
</style>
